(function () {
    'use strict';

    angular.module("imApp").factory("p2UpdateTableEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getUpdateTable: function (parms) {
                return $ihttp.post({
                    method: 205,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 206,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
